import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import logo from "../../../../resources/img/Events/Marketing/logo.png";

export const Section15to16 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec15_16}`}>
                <animated.div className={`${styles.sec15_16_background} ${styles.ab}`} style={{
                    translateY: spring.x.to({
                        range: [0, 0.25, 1],
                        output: [130, 0, 0]
                    }).to(x => `${x}vh`)
                }}/>
                <div className={`${styles.sec15_16__div01} ${styles.sec15_16__content}`}>
                    <animated.span className={`${styles.sec15_16__div01__font01} ${styles.notoBold} ${styles.ab}`} style={{
                        opacity: spring.x.to({
                            range: [0, 0.15, 0.2, 0.55, 0.6, 1],
                            output: [0, 0, 1, 1, 0, 0]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [0, 0.15, 0.2, 0.55, 0.6, 1],
                            output: [10, 10, 0, 0, -10, -10]
                        }).to(x => `${x}vh`)
                    }}>쓸수록</animated.span>
                    <animated.span className={`${styles.sec15_16__div01__font02} ${styles.notoBold} ${styles.ab}`} style={{
                        opacity: spring.x.to({
                            range: [0, 0.35, 0.4, 0.55, 0.6, 1],
                            output: [0, 0, 1, 1, 0, 0]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [0, 0.35, 0.4, 0.55, 0.6, 1],
                            output: [10, 10, 0, 0, -10, -10]
                        }).to(x => `${x}vh`)
                    }}>혜택이 쌓이는 곳</animated.span>
                </div>
                <animated.div className={`${styles.sec15_16__div02} ${styles.sec15_16__content}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.57, 0.63, 0.85, 1],
                        output: [0, 0, 1, 1, 0]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.57, 0.63, 0.85, 1],
                        output: [10, 10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>
                    <img className={`${styles.sec15_16__div02__img} ${styles.ab}`} src={logo} alt="빗썸 로고" />
                    <div className={`${styles.sec15_16__div02__btn} ${styles.ab}`}>
                        <a href='#' className={styles.sec15_16__div02__btn__btn01} target="_blank">빗썸 마일리지</a>
                        <a href='#' className={styles.sec15_16__div02__btn__btn02} target="_blank">빗썸 플러스</a>
                        <a href='#' className={styles.sec15_16__div02__btn__btn03} target="_blank">빗썸 앱</a>
                    </div>
                </animated.div>
                <animated.span className={`${styles.sec15_16__circle01} ${styles.ab}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.16, 0.28, 1],
                        output: [0, 0, 1, 1]
                    }).to(x => x),
                }}></animated.span>
                <animated.span className={`${styles.sec15_16__circle02} ${styles.ab}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.15, 0.27, 1],
                        output: [0, 0, 1, 1]
                    }).to(x => x),
                }}></animated.span>
            </div>
        </animated.div>
    )
}